import { trpc } from "@util/trpc/trpcClient";

/**
 * Mutation hook to mark notifications as "read" by the current user in the backend
 */
export default function useMarkNotificationsRead() {
  const utils = trpc.useUtils();

  return trpc.inAppNotifications.markInAppNotificationsRead.useMutation({
    onMutate: async ({ inAppNotificationIds }) => {
      // Cancel any outgoing refetches that may overwrite our update
      await utils.inAppNotifications.getInAppNotifications.cancel();

      // Snapshot the current notifs so we can rollback on error
      const prevNotifs =
        utils.inAppNotifications.getInAppNotifications.getData();

      // Optimistically update the cache
      utils.inAppNotifications.getInAppNotifications.setData(
        undefined,
        (data) => {
          if (!data) {
            return undefined;
          }

          return {
            ...data,
            inAppNotifications: data.inAppNotifications.map((n) =>
              inAppNotificationIds.includes(n.id) ? { ...n, read: true } : n,
            ),
          };
        },
      );
      // // Pass the snapshot along so onError can rollback
      return prevNotifs;
    },
    onError: (_error, _variables, prevNotifs) => {
      // Rollback to the snapshot
      utils.inAppNotifications.getInAppNotifications.setData(
        undefined,
        prevNotifs,
      );
    },
    onSettled: () => {
      // Trigger a refetch either way
      void utils.inAppNotifications.getInAppNotifications.invalidate();
    },
  });
}
